import { useTranslation } from 'react-i18next';
import { TeleportIcon } from '@icons';
import { useMytaverse } from '@providers/MytaverseProvider';
import { useMytaverseEvent } from '@core/dashboard/providers';
import HomeBarButton from '../../HomeBarButton';
import { WebsocketAction } from '@interfaces/webSocketConnectionInfo';
import { NOTIFICATION_TYPES, useNotification } from '@components/Notification';
import { getClientSpecificCanTeleport } from '@helpers/clientSpecificUtils';
import { getNotification } from '@components/Notification/helpers';
import { Box } from '@mui/material';

const Teleport = () => {
  const { t: translate } = useTranslation();
  const { sendMessageToUnreal } = useMytaverse();
  const { isTeleportingToRoomByUnreal, currentEvent, teleportEnabled } =
    useMytaverseEvent();
  const { showNotification } = useNotification();
  const { canTeleport, notificationMessage } =
    getClientSpecificCanTeleport(currentEvent);

  const handleTeleportClick = () => {
    const action = WebsocketAction.BeamMeUp;
    sendMessageToUnreal({
      action,
      state: isTeleportingToRoomByUnreal,
    });
  };

  const showNotificationIfCantTeleport = () => {
    showNotification(
      getNotification({
        message: translate(`notifications.${notificationMessage}`),
        type: NOTIFICATION_TYPES.INFO,
        closeManually: false,
        withDismissButton: false,
        withReloadButton: false,
      }),
    );
  };

  if (teleportEnabled) {
    return (
      <Box
        onClick={() => {
          !canTeleport && showNotificationIfCantTeleport();
        }}
      >
        <HomeBarButton
          handleClick={handleTeleportClick}
          icon={<TeleportIcon />}
          label={translate('tooltips.teleport')}
          isActive={isTeleportingToRoomByUnreal}
          disabled={!canTeleport}
        />
      </Box>
    );
  } else {
    return null;
  }
};

export default Teleport;
